import {Predicate} from "../../../../types/GenericTypes";
import {AdviserRiskRow, BranchRiskRow, BrokerRiskRow, ClientRiskRow} from "../risk-model/RiskSummary";

export interface ModelFilter {
    brokerFilter: Predicate<BrokerRiskRow>;
    branchFilter: Predicate<BranchRiskRow>;
    adviserFilter: Predicate<AdviserRiskRow>;
    clientFilter: Predicate<ClientRiskRow>;
}

export function NoOpModelFilter(): ModelFilter {
    return {
        brokerFilter: () => true,
        branchFilter: () => true,
        adviserFilter: () => true,
        clientFilter: () => true
    };
}

function ExcludeEverythingFilter(): ModelFilter {
    return {
        brokerFilter: () => false,
        branchFilter: () => false,
        adviserFilter: () => false,
        clientFilter: () => false
    };
}

export function ClientFilter(filter: Predicate<ClientRiskRow>): ModelFilter {
    const base = ExcludeEverythingFilter();
    base.clientFilter = filter;
    return base;
}

export function AdviserFilter(filter: Predicate<AdviserRiskRow>): ModelFilter {
    const base = ExcludeEverythingFilter();
    base.adviserFilter = filter;
    return base;
}

export function BranchFilter(filter: Predicate<BranchRiskRow>): ModelFilter {
    const base = ExcludeEverythingFilter();
    base.branchFilter = filter;
    return base;
}

export function BrokerFilter(filter: Predicate<BrokerRiskRow>): ModelFilter {
    const base = ExcludeEverythingFilter();
    base.brokerFilter = filter;
    return base;
}
